import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "tab" }
const _hoisted_6 = { class: "box" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "pic" }
const _hoisted_9 = { class: "box" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "box" }
const _hoisted_12 = { class: "items" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "cont" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "items" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "warp" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "items" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "an" }
const _hoisted_24 = { class: "warp" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "sider"
}
const _hoisted_31 = ["onClick"]

import {
  reactive,
  ref,
  onMounted,
  getCurrentInstance,
  onUnmounted,
  watch,
} from "vue";

import Nav from "@/components/nav/Index.vue";
import { getEnum, getAbout } from "@/api/index";

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const videoPlayer = ref(null);
const props = __props;

const mb = ref(false);
mb.value = props.isMobile;
const ctx: any = getCurrentInstance();
const datas: any = reactive({
  current: 0,
  play: false,
  key: "ABOUT_US_INTRO",
  banner: "",
  tabs: {},
  data: {},
  filurl: localStorage.getItem("fileUrel"),
});

watch(
  () => props.isMobile,
  (newv, oldv) => {
    props.isMobile ? (mb.value = true) : (mb.value = false);
  }
);
const getBanner = (banner: any) => {
  datas.banner = banner;
};

const open = (url: any) => {
  window.open(url, "_blank");
};

const play = () => {
  datas.play = true;
  ctx.refs["videoPlayer"][0].play();
};
const getTab = () => {
  getEnum("ABOUT_US").then((res: any) => {
    console.log(res);

    for (const item of res.data) {
      if (item.extData) item.fileUrl = localStorage.getItem("fileUrel") + item.extData;

      if (item.enumKey != "ABOUT_US_VIDEO") {
        datas.tabs[item.enumKey] = item;
      }
    }
    console.log(datas.tabs);
  });
};

const numberGrow = (el: any, current: number) => {
  let start = 0;
  current > 2000 ? (start = 2000) : (start = 1);
  setTimeout(() => {
    let timer = setInterval(function () {
      start += 1;
      if (start > current) {
        clearInterval(timer);
        start = current;
      } else {
        ctx.refs[el][0] ? (ctx.refs[el][0].innerHTML = start) : "";
      }
    }, 10);
  }, 200);
};

const scroll = (key: any) => {
  datas.key = key;
  window.scrollTo(0, ctx.refs[key][0].offsetTop);
};

const getAboutAll = () => {
  getAbout().then((res: any) => {
    for (const item of res.data) {
      if (item.aboutUsType === "ABOUT_US_CULTURE") {
        for (const o of item.others) {
          o.description = o.description.split(";").filter(function (s: any) {
            return s && s.trim();
          });
        }
      }

      if (item.aboutUsType === "ABOUT_US_HONOUR") {
        item.oth = [];
        for (let i = 0; i < item.others.length; i += 3) {
          item.oth.push(item.others.slice(i, i + 3));
        }
      }

      if (item.aboutUsType === "ABOUT_US_CONTACT") {
        for (const o of item.others) {
          o.description = o.description.split(",split,").filter(function (s: any) {
            return s && s.trim();
          });
        }
      }
    }

    datas.data = res.data;
  });
};

const handleScroll = (e: any) => {
  const scrollTop = e.target.scrollingElement.scrollTop;
  for (const k in datas.tabs) {
    if (
      ctx.refs[k][0].offsetTop - 300 < scrollTop &&
      ctx.refs[k][0].offsetTop + 300 > scrollTop
    ) {
      datas.key = k;
    }
  }
};

const next = () => {
  ctx.refs["acrRef"][0].next();
};

const prev = () => {
  ctx.refs["acrRef"][0].prev();
};

onMounted(() => {
  getTab();
  getAboutAll();
  window.addEventListener("scroll", handleScroll, false);
  setTimeout(() => {
    ctx.refs["videoPlayer"][0].addEventListener("ended", () => {
      datas.play = false;
    });
  }, 100);
});
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll, false);
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value ? 'Mobile' : 'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl + datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.tabs, (v, k) => {
              return (_openBlock(), _createElementBlock("li", {
                key: k,
                onClick: ($event: any) => (scroll(k))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "img",
                    style: _normalizeStyle({
                    background: `url(${v.fileUrl}) 100%`,
                    backgroundSize: 'cover',
                  })
                  }, null, 4)
                ]),
                _createTextVNode(" " + _toDisplayString(v.enumName), 1)
              ], 8, _hoisted_7))
            }), 128))
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (item.aboutUsType == 'ABOUT_US_INTRO')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "info",
              ref_for: true,
              ref: item.aboutUsType,
              style: _normalizeStyle({
          background: `url(${datas.filurl + item.fileName})`,
          backgroundSize: 'cover',
        })
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.others, (l, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _createElementVNode("span", {
                        class: "n",
                        ref_for: true,
                        ref: 'num' + i
                      }, _toDisplayString(numberGrow("num" + i, l.title)), 513),
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(l.description.substring(0, 1)) + " ", 1),
                        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(_toDisplayString(l.description.substring(1)), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", {
                  class: "",
                  innerHTML: item.description
                }, null, 8, _hoisted_10)
              ])
            ], 4))
          : _createCommentVNode("", true),
        (item.aboutUsType == 'ABOUT_US_CULTURE')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "cul",
              ref_for: true,
              ref: item.aboutUsType,
              style: _normalizeStyle({
          background: `url(${datas.filurl + item.fileName})`,
          backgroundSize: 'cover',
        })
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.others, (l, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(l.title), 1),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l.description, (p, n) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: n,
                              class: "p"
                            }, _toDisplayString(n + 1) + "、" + _toDisplayString(p), 1))
                          }), 128))
                        ]),
                        _createElementVNode("img", {
                          src: datas.filurl + l.fileName,
                          alt: ""
                        }, null, 8, _hoisted_15)
                      ])
                    ]))
                  }), 128))
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "more" }, "更多企业文化请前往我司了解", -1))
              ])
            ], 4))
          : _createCommentVNode("", true),
        (item.aboutUsType == 'ABOUT_US_HONOUR')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "hon",
              ref_for: true,
              ref: item.aboutUsType
            }, [
              _createElementVNode("h1", null, _toDisplayString(item.title), 1),
              _createVNode(_component_el_carousel, {
                ref_for: true,
                ref: "acrRef",
                interval: 5000,
                autoplay: false,
                arrow: "never",
                "indicator-position": "outside",
                height: "3.6rem"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.oth, (l, i) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: i }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l, (p, n) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "item",
                              key: n
                            }, [
                              _createElementVNode("img", {
                                src: datas.filurl + p.fileName,
                                alt: ""
                              }, null, 8, _hoisted_17),
                              _createElementVNode("h3", null, _toDisplayString(p.title), 1),
                              (!mb.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(p.description), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1536),
              _createElementVNode("div", {
                class: "arr a1",
                onClick: prev
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "iconfont icon-xiangzuo1" }, null, -1)
              ]))]),
              _createElementVNode("div", {
                class: "arr a2",
                onClick: next
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "iconfont icon-xiangyou1" }, null, -1)
              ]))])
            ], 512))
          : _createCommentVNode("", true),
        (item.aboutUsType == 'ABOUT_US_CARE')
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "about",
              ref_for: true,
              ref: item.aboutUsType,
              style: _normalizeStyle({
          background: `url(${datas.filurl + item.fileName})`,
          backgroundSize: 'cover',
        })
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                _createElementVNode("p", {
                  class: "fon2",
                  innerHTML: item.description
                }, null, 8, _hoisted_20),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.others, (l, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["item", i < 2 ? 'l' + i : 'l3']),
                      key: i
                    }, [
                      _createElementVNode("img", {
                        src: datas.filurl + l.fileName,
                        alt: ""
                      }, null, 8, _hoisted_22),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "know-top" }, null, -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "know-left" }, null, -1)),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "know-right" }, null, -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "know-bottom" }, null, -1)),
                        _createElementVNode("p", null, _toDisplayString(l.description), 1)
                      ])
                    ], 2))
                  }), 128))
                ])
              ])
            ], 4))
          : _createCommentVNode("", true),
        (item.aboutUsType == 'ABOUT_US_CONTACT')
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: "contact",
              ref_for: true,
              ref: item.aboutUsType,
              style: _normalizeStyle({
          background: `url(${datas.filurl + item.fileName})`,
          backgroundSize: 'cover',
        })
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("img", {
                      src: datas.filurl + item.others[0].fileName,
                      alt: ""
                    }, null, 8, _hoisted_27)
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.others, (l, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        (i != 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                              _createTextVNode(_toDisplayString(l.title) + "： " + _toDisplayString(l.description[0]) + " ", 1),
                              (l.description.length > 1)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: "iconfont icon-dingwei",
                                    onClick: ($event: any) => (open(l.description[1]))
                                  }, null, 8, _hoisted_29))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (!mb.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.tabs, (v, k) => {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                key: k,
                class: _normalizeClass(k == datas.key ? 'check' : ''),
                onClick: ($event: any) => (scroll(k))
              }, _toDisplayString(v.enumName), 11, _hoisted_31)), [
                [_vShow, k != 'enumKey']
              ])
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})